import type React from "react";
import { useRef } from "react";
import { AttachmentItem } from "./attachment-item";
import { Button } from "./button";

type AttachmentPickerProps = {
  file: File | null;
  onFileChange: (file: File | null) => void;
  allowedFileTypes: string[];
  disabled?: boolean;
  label?: string;
};

export const AttachmentPicker = ({
  file,
  onFileChange,
  allowedFileTypes,
  disabled = false,
  label = "Add Attachment",
}: AttachmentPickerProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleAddClick = () => {
    inputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    if (f) onFileChange(f);
    e.target.value = "";
  };

  if (file) {
    return (
      <AttachmentItem
        filename={file.name}
        onDeleteClick={() => onFileChange(null)}
        canDelete
        className="h-6 w-full"
      />
    );
  }

  return (
    <Button
      type="button"
      variant={"ghost"}
      className="flex items-center text-gray-500 text-xs font-normal hover:bg-white !p-0"
      onClick={disabled ? undefined : handleAddClick}
      onKeyDown={(e) => {
        if ((e.key === "Enter" || e.key === " ") && !disabled) {
          handleAddClick();
        }
      }}
      disabled={disabled}
      leftIcon="circle-plus"
    >
      <span className="whitespace-normal break-words text-left block">
        {label}
      </span>
      <input
        ref={inputRef}
        type="file"
        disabled={disabled}
        accept={allowedFileTypes.join(",")}
        className="hidden"
        onChange={handleFileChange}
      />
    </Button>
  );
};
